import React, { Component } from 'react';
import { Map, GoogleApiWrapper} from 'google-maps-react';

const mapStyles = {
    width: '90%',
    height: '50%'
};

const MapContainer = (props) => {
    return (
        <Map google={props.google} zoom={14} style={mapStyles} initialCenter={{ lat: 18.5778990433575, lng: 73.72130105306097 }} />
);
}
export default GoogleApiWrapper({
    apiKey: 'AIzaSyAyesbQMyKVVbBgKVi2g6VX7mop2z96jBo'
})(MapContainer) 